module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict02_01_sp-c4813d10f8b339995b1e9bdd42d67c1f.webp";